module.exports = __webpack_public_path__ + "img/no_routes.8a1172d6.png";